import React from 'react';
import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from 'next-seo';
import RoundedButton from 'components/RoundedButton';
import Separator from 'components/Separator';
import YouTubeVideo from 'components/YouTubeVideo';
import { getCta } from 'utils/common';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/meet-our-25k-prize-winner`;

  return (
    <MainLayout>
      <NextSeo
        title="Meet our £25k prize winner | Win Epic Prizes | DAYMADE"
        description="Harriet G won a £25,000 DAYMADE prize from the weekly draw. Will you be our next £25k prize winner? Enter now for your chance to win big."
        openGraph={{
          title: 'Meet our £25k prize winner | Win Epic Prizes | DAYMADE',
          description:
            'Harriet G won a £25,000 DAYMADE prize from the weekly draw. Will you be our next £25k prize winner? Enter now for your chance to win big.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/meet-our-25k-prize-winner',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'Our £25,000 jackpot winner, Harriet, standing in front of a backdrop of plants and a large window with a view over London.',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'winner,competition,daymade,jackpot,raffle,japan,adventure,travel,prize,win a prize,online,dream,win a holiday',
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="Our £25,000 jackpot winner, Harriet, standing in front of a backdrop of plants and a large window with a view over London."
        heroImageYPosition="21%"
      >
        <>
          <h1 style={{ fontSize: '1.6em', lineHeight: '1.4em' }}>
            Meet Harriet, our <strong>£25k DAYMADE jackpot prize winner</strong>
            !
          </h1>

          <p className="subheading">
            We took Harriet out on a Japan-themed day in London to get to know
            her and hear all about her plans for her £25k prize.
          </p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          >
            by Abbi James
          </p>

          <p>*drumroll please*</p>

          <p>We can now announce the winner of our £25,000 jackpot prize...</p>

          <h3 style={{ margin: '0.5em 0 1em' }}>HARRIET GLASS!</h3>

          <p>
            Picture yourself: staring out the bus window on your way to work
            while getting a call from an unknown number that you have just won
            the jackpot. It happened to Harriet, one of our Premium Subscribers,
            who won a £25k DAYMADE prize of her choice, matching 6 numbers on
            the 23rd July. We couldn’t hold our excitement for Harriet, so on
            Saturday 16th October we put together a day-out for her, themed
            around her prize choice. Can you guess which prize she picked?! Read
            on to find out what Japan-themed shenanigans we got up to, and
            Harriet’s experience winning our £25k DAYMADE prize!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt="Harriet stood beneath a row of red gates that resemble Japanese 'torii' gates."
            className="singleBlogImage"
          />

          <p>
            We had the most AMAZING day spending time with Harriet and her lucky
            plus one, Emma.
          </p>

          <p>
            Needless to say, Harriet was over the moon when she found out she’d
            won, albeit a little shocked:
          </p>

          <p className="quote">
            “Well you called me before I had my coffee so I was a bit
            stunned!...I thought I was maybe still asleep! I was like ‘did I
            hear that right? Did you actually say what I thought you just
            said?’. I just thought ‘I’m sorry...this has to be a prank!’. Once
            it sunk in, I was just like ‘how? This is amazing!’.”
          </p>

          <p>
            We’ve all daydreamed at one point or another about how we’d react if
            we won a prize competition or won an Oscar (just me? Oh ok).
            Harriet’s reaction via group text:
          </p>

          <h3 style={{ margin: '0.5em 0 1em' }}>
            "You’re never gonna guess what just happened!"
          </h3>

          <p>
            The rest of Harriet’s day was a bit of a blur – after all, how do
            you top such exciting news on a workday?{' '}
            <span className="quote">
              “I had to go into work and be professional and talk to customers
              and I was just sat there going ‘YES!!!’”.
            </span>{' '}
            *little happy dance*
          </p>

          <p>
            When it came to choosing her prize, Harriet was stunned with the
            choice. Would she go for the road trip through New Zealand? The full
            house make-over? The bucket-list trip to Peru? A water bungalow in
            The Maldives? After some consideration, Harriet made her mind up:
            the 2-week trip through Japan was her winner! Japan has been at the
            top of Harriet’s bucketlist since she was young, but she never
            dreamed she’d be able to visit it on such a huge budget:
          </p>

          <p>
            <span className="quote">
              “I always thought if I’m going to do it, it’s going to be on a
              budget the whole way with cheap hotels and hostels…the chance to
              actually do it in proper style is just…I never thought I’d ever
              get to do that. Ever. I’ve done budget travel for the past 10
              years…it’s always on a shoestring…but I’ve never been able to do
              something like this!“.
            </span>{' '}
            Well we think it’s about time for a little luxury – five star
            accommodation, unlimited railcards and endless activities for two
            seems like a well-deserved treat.
          </p>

          <p>
            Japan has so much to offer, from exploring Mount Fuji to adventuring
            through Shiraito Falls. Harriet’s a self-proclaimed massive fan of
            history and the culture, so she can’t wait to discover castles and
            temples during her visit. Whilst a different type of castle is
            involved, Harriet also can’t wait to visit Tokyo Disneyland!
          </p>

          <p>
            Whilst Harriet hasn’t yet decided who the lucky plus one will be to
            join her on her trip to Japan, Callum was quick to volunteer.{' '}
            <span className="quote">“I volunteer as tribute!”</span>, he
            said…taking one for the team I’m sure he’d say! Although we’re sure
            Harriet will have no shortage of friends eager to join her on her
            adventure.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt="Harriet and her plus one for the day, Emma, enjoying some cocktails."
            className="singleBlogImage"
          />

          <p>
            Harriet joined DAYMADE on a bit of a whim, but since then she’s
            planted a whopping 92 trees! We couldn’t help but ask her how she
            found out about DAYMADE:
          </p>

          <p className="quote">
            “I think I saw someone posting about it and thought “oh, that looks
            quite interesting” and clicked on it. I thought, why not, it’s only
            a couple of quid a week, I’ll try my luck, you never know….and here
            we are! About a month before I won, I was doing a clear out of my
            direct debits so I thought right, I’ll pause that for a little bit.
            I didn’t actually hit ‘submit’… oh thank goodness for that! A few
            weeks later if my numbers had come up, I would have cried.”
          </p>

          <p>
            There’s no doubt that Harriet’s one lucky lass, so we asked her what
            she’d like to share with others thinking of joining DAYMADE as a
            Premium Subscriber:
          </p>

          <p className="quote">
            “Why not, you know? Just in the past couple weeks I’ve actually won
            a £25 voucher two weeks ago, and I won a £5 one yesterday. And you
            plant trees with every entry, so you’re saving the planet and you
            get a nice little prize out of it. It’s good chances. And it’s just
            good fun, it’s nice getting that email on Friday evening being like
            ‘oh look!’.”
          </p>

          <p>
            We couldn’t have said it better ourselves. Harriet’s lifelong dream
            of visiting Japan is coming true, and you could be our next £25,000
            winner! Enter now for your chance to win big for the price of a
            coffee.
          </p>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px', margin: '1.5em 0' }}
          >
            Enter Now
          </RoundedButton>

          <Separator style={{ margin: '1.5em 0 2em' }} />

          <p>
            Want to get a sneak peak of Harriet’s Japan-themed day in London?
            Check out our vlog here:
          </p>

          <YouTubeVideo
            videoUrl="https://www.youtube-nocookie.com/embed/FMx9L7CwKAM"
            style={{
              margin: '2em 0 0',
            }}
          />
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
